import React, { useState } from 'react';

interface SplitTextModalProps {
  isOpen: boolean;
  onClose: () => void;
  onApply: (delimiter: string) => void;
}

export const SplitTextModal: React.FC<SplitTextModalProps> = ({ isOpen, onClose, onApply }) => {
  const [delimiter, setDelimiter] = useState(',');

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (delimiter) {
      onApply(delimiter);
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 pointer-events-none">
      <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-xs border border-gray-300 pointer-events-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-gray-800">Split Text to Columns</h2>
          <button type="button" onClick={onClose} className="text-gray-400 hover:text-gray-600">✕</button>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Delimiter</label>
            <input
              type="text"
              placeholder="e.g., , or - or space"
              required
              autoFocus
              className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-green-500 outline-none"
              value={delimiter}
              onChange={(e) => setDelimiter(e.target.value)}
            />
          </div>
          
          <div className="flex justify-end space-x-3 mt-6 pt-2">
            <button type="button" onClick={onClose} className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded font-medium transition text-sm">
              Cancel
            </button>
            <button type="submit" className="px-4 py-2 bg-blue-50 text-blue-700 border border-blue-200 rounded hover:bg-blue-100 font-medium shadow-sm transition text-sm">
              Split
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};